import { Collapse } from "antd";
import * as React from "react";
import { MdmTable } from "src/components/MdmTable";
import { staticRtLoader } from "src/components/ReactiveTable/loaders";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";
import { ZId } from "src/types";

export type SpecLinksSection<T extends { id: ZId }> = {
  key: string;
  label: string;
  dataSource: T[] | null | undefined;
  columns: RtColumn<T>[];
};

type PropsSpecLinksView<T extends { id: ZId }> = {
  sections: SpecLinksSection<T>[];
};

type PropsSpecLinksTable<T extends { id: ZId }> = {
  dataSource: SpecLinksSection<T>["dataSource"];
  columns: SpecLinksSection<T>["columns"];
};

const SpecLinksTable = <T extends { id: ZId }>({
  dataSource,
  columns,
}: PropsSpecLinksTable<T>) => {
  const tableStore = React.useMemo(() => {
    const rows = dataSource ?? [];

    return new RtStore<T, {}>({
      rowKey: "id",
      loader: staticRtLoader(rows),
    });
  }, [dataSource]);

  return (
    <MdmTable
      store={tableStore}
      columns={columns}
      resizableColumns
      components={{ Footer: () => null }}
    />
  );
};

export const SpecLinksView = <T extends { id: ZId }>({
  sections,
}: PropsSpecLinksView<T>) => {
  const items = sections.map((section: SpecLinksSection<T>) => ({
    key: section.key,
    label: section.label,
    styles: {
      body: {
        padding: 4,
      },
    },
    children: (
      <SpecLinksTable
        dataSource={section.dataSource}
        columns={section.columns}
      />
    ),
  }));

  return <Collapse items={items} />;
};
